import React, { useEffect, useState } from "react";
import { Card, Col, Container, FormGroup, Label, Row } from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import "./Brokers.scss";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { imageUpload } from "../../services/BannersServices";
import Dropzone from "react-dropzone";
import { Constants } from "../../Constants";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../components/loading/Loading";
import { stateToHTML } from "draft-js-export-html";
import { useHistory } from "react-router";
import ViewInWeb from "../../components/Common/ViewInWeb";
import axios from "axios";
import { stateFromHTML } from "draft-js-import-html";
import Icon from "@ailibs/feather-react-ts/dist/Icon";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

const instance = axios.create({ baseURL: Constants.BASE_URL });

const updateBrokers = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.put(
      `/brokers`,
      { ...data, type: "comercial" },
      httpOptions
    );
  } catch (error) {
    throw error;
  }
};

const fetchBrokers = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.get(`/brokers?type=comercial`, httpOptions);
  } catch (error) {
    throw error;
  }
};

function Brokers(props: any) {
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const [bannerDesktop, setBannerDesktop] = useState();
  const [bannerMobile, setBannerMobile] = useState();
  const [head, setHead] = useState(EditorState.createEmpty());
  const [footer, setFooter] = useState(EditorState.createEmpty());
  const [content, setContent] = useState<any>([]);
  const [imageTmp, setImageTmp] = useState("");
  const [descriptionTmp, setDescriptionTmp] = useState(
    EditorState.createEmpty()
  );
  const [contentIdEdit, setContentIdEdit] = useState<any>(null);

  useEffect(() => {
    fetch();
  }, []);

  const uploadCallback = async (file: any) => {
    const result = {
      data: {
        link: "",
      },
    };
    try {
      var form = new FormData();
      form.append("file", file);
      let response = await imageUpload({
        form,
        token: "",
        type: "textEdition",
      });
      result.data.link = `${Constants.BASE_URL}${response.data.data.image}`;
    } catch (error: any) {
      console.log(error.response);
    }
    return result;
  };

  const fetch = async () => {
    try {
      setLoading(true);
      let response = await fetchBrokers({
        token: "",
      });
      const { banner_desktop, banner_mobile, content, footer, head } =
        response.data.data;
      setBannerDesktop(banner_desktop);
      setBannerMobile(banner_mobile);
      setFooter(EditorState.createWithContent(stateFromHTML(footer)));
      setHead(EditorState.createWithContent(stateFromHTML(head)));

      const contentToArray = JSON.parse(content);
      const contentToHook: any = [];
      contentToArray.map((item: any) => {
        // Suponiendo que item.description es una string que contiene HTML.

        const blocksFromHtml = htmlToDraft(item.description);
        const { contentBlocks, entityMap } = blocksFromHtml;

        // Ahora, utiliza estos bloques y mapas de entidades para crear un ContentState
        const contentState = ContentState.createFromBlockArray(
          contentBlocks,
          entityMap
        );

        // Finalmente, crea el EditorState usando el ContentState
        const editorState = EditorState.createWithContent(contentState);

        contentToHook.push({
          image: item.image,
          description: editorState,
        });
      });

      setContent(contentToHook);
      setLoading(false);
    } catch (error: any) {
      console.log(error);
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const handleAcceptedFiles = async (files: any, hook: string) => {
    for (let file of files) {
      try {
        var form = new FormData();
        form.append("file", file);
        let response = await imageUpload({
          form,
          token: "",
          type: "news",
        });
        if (hook === "banner_desktop") {
          setBannerDesktop(response.data.data.image);
        } else if (hook === "banner_mobile") {
          setBannerMobile(response.data.data.image);
        } else {
          setImageTmp(response.data.data.image);
        }
      } catch (error: any) {
        console.log(error.response);
      }
    }
  };

  const save = async () => {
    setLoading(true);
    try {
      let data = {
        head: stateToHTML(head.getCurrentContent()),
        footer: stateToHTML(footer.getCurrentContent()),
        bannerDesktop,
        bannerMobile,
        content: content.map((item: any) => ({
          image: item.image,
          description: draftToHtml(
            convertToRaw(item.description.getCurrentContent())
          ),
        })),
      };

      await updateBrokers({
        token: "",
        ...data,
      });

      setLoading(false);
      toast(`Brokers actualizado con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error: any) {
      setLoading(false);
      if (error?.response?.status === 401) {
        history.push("/logout");
      }
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const removeContent = (index: number) => {
    const contentTmp = content;
    contentTmp.splice(index, 1);
    setContent([...contentTmp]);
  };

  const editContent = (item: any, index: number) => {
    setContentIdEdit(index);
    setImageTmp(item.image);
    setDescriptionTmp(item.description);
  };

  return (
    <React.Fragment>
      <ToastContainer />
      {loading && <Loading />}
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            title="Propuesta comercial"
            breadcrumbItem="Propuesta comercial"
          />
          <Row style={{ marginBottom: "1rem" }}>
            <Col className="row">
              <FormGroup className="col-md-6">
                <Label>Banner Desktop</Label>
                <Dropzone
                  onDrop={(acceptedFiles) => {
                    handleAcceptedFiles(acceptedFiles, "banner_desktop");
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className="dropzone">
                      <div
                        className="dz-message needsclick mt-2"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="mb-3">
                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                        </div>
                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </div>
                  )}
                </Dropzone>
                <div className="dropzone-previews mt-3 mb-3" id="file-previews">
                  {bannerDesktop && (
                    <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                      <div className="p-2">
                        <Row className="align-items-center">
                          <Col className="col-auto">
                            <img
                              data-dz-thumbnail=""
                              height="80"
                              className="avatar-sm rounded bg-light"
                              alt=""
                              src={`${Constants.BASE_URL}${bannerDesktop}`}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Card>
                  )}
                </div>
              </FormGroup>
              <FormGroup className="col-md-6">
                <Label>Banner Mobile</Label>
                <Dropzone
                  onDrop={(acceptedFiles) => {
                    handleAcceptedFiles(acceptedFiles, "banner_mobile");
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className="dropzone">
                      <div
                        className="dz-message needsclick mt-2"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="mb-3">
                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                        </div>
                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </div>
                  )}
                </Dropzone>
                <div className="dropzone-previews mt-3 mb-3" id="file-previews">
                  {bannerMobile && (
                    <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                      <div className="p-2">
                        <Row className="align-items-center">
                          <Col className="col-auto">
                            <img
                              data-dz-thumbnail=""
                              height="80"
                              className="avatar-sm rounded bg-light"
                              alt=""
                              src={`${Constants.BASE_URL}${bannerMobile}`}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Card>
                  )}
                </div>
              </FormGroup>
            </Col>
          </Row>

          <FormGroup className="mt-2" style={{ marginBottom: "2rem" }}>
            <Label>Cabecera</Label>
            <Editor
              toolbarClassName="toolbarClassName"
              wrapperClassName="wrapperClassName"
              editorClassName="editorClassName"
              toolbar={{
                options: ["inline", "blockType", "link", "emoji", "image"],
                inline: { inDropdown: true },
                link: { inDropdown: true },
                image: { uploadCallback },
              }}
              editorState={head}
              onEditorStateChange={(d: any) => setHead(d)}
            />
          </FormGroup>

          <Row>
            <Label>Contenido</Label>
            <Col md={4}>
              <FormGroup className="mt-2" style={{ marginBottom: "2rem" }}>
                <Dropzone
                  onDrop={(acceptedFiles) => {
                    handleAcceptedFiles(acceptedFiles, "image");
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className="dropzone">
                      <div
                        className="dz-message needsclick mt-2"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="mb-3">
                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                        </div>
                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </div>
                  )}
                </Dropzone>
                <div className="dropzone-previews mt-3" id="file-previews">
                  {imageTmp && (
                    <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                      <div className="p-2">
                        <Row className="align-items-center">
                          <Col className="col-auto">
                            <img
                              data-dz-thumbnail=""
                              height="80"
                              className="avatar-sm rounded bg-light"
                              alt=""
                              src={`${Constants.BASE_URL}${imageTmp}`}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Card>
                  )}
                </div>
              </FormGroup>
            </Col>
            <Col md={8}>
              <FormGroup className="mt-2" style={{ marginBottom: "2rem" }}>
                <Editor
                  toolbarClassName="toolbarClassName"
                  wrapperClassName="wrapperClassName"
                  editorClassName="editorClassName"
                  toolbar={{
                    options: [
                      "inline",
                      "blockType",
                      "link",
                      "emoji",
                      "image",
                      "colorPicker",
                      "textAlign",
                    ],
                    inline: { inDropdown: true },
                    link: { inDropdown: true },
                    image: { uploadCallback },
                    colorPicker: {
                      colors: [
                        "rgb(1,51,153)",
                        "rgb(73,80,87)",
                        "rgb(97,189,109)",
                        "rgb(26,188,156)",
                        "rgb(84,172,210)",
                        "rgb(44,130,201)",
                        "rgb(147,101,184)",
                        "rgb(71,85,119)",
                        "rgb(204,204,204)",
                        "rgb(65,168,95)",
                        "rgb(0,168,133)",
                        "rgb(61,142,185)",
                        "rgb(41,105,176)",
                        "rgb(85,57,130)",
                        "rgb(40,50,78)",
                        "rgb(0,0,0)",
                        "rgb(247,218,100)",
                        "rgb(251,160,38)",
                        "rgb(235,107,86)",
                        "rgb(226,80,65)",
                        "rgb(163,143,132)",
                        "rgb(239,239,239)",
                        "rgb(255,255,255)",
                        "rgb(250,197,28)",
                        "rgb(243,121,52)",
                        "rgb(209,72,65)",
                        "rgb(184,49,47)",
                        "rgb(124,112,107)",
                        "rgb(209,213,216)",
                      ],
                    },
                  }}
                  editorState={descriptionTmp}
                  onEditorStateChange={(d: any) => setDescriptionTmp(d)}
                />
              </FormGroup>
            </Col>
            <button
              className="btn btn-primary waves-effect waves-light mb-2"
              onClick={() => {
                if (contentIdEdit !== null) {
                  const contentTmp = content.map((item: any, index: number) => {
                    if (index === contentIdEdit) {
                      return {
                        description: descriptionTmp,
                        image: imageTmp,
                      };
                    }
                    return item;
                  });
                  setContent(contentTmp);
                  setContentIdEdit(null);
                } else {
                  setContent([
                    ...content,
                    { description: descriptionTmp, image: imageTmp },
                  ]);
                }
                setDescriptionTmp(EditorState.createEmpty());
                setImageTmp("");
              }}
              style={{
                width: "max-content",
                marginLeft: "auto",
                marginRight: "15px",
              }}
            >
              {contentIdEdit !== null ? "Editar" : "Agregar"}
            </button>
          </Row>

          {console.log(
            draftToHtml(convertToRaw(descriptionTmp.getCurrentContent()))
          )}

          {content.map((item: any, index: number) => (
            <Row className={`mb-4 ${index % 2 !== 0 ? "background-grey" : ""}`}>
              <div
                style={{
                  position: "absolute",
                  display: "flex",
                  justifyContent: "end",
                  gap: "0.5rem",
                  zIndex: 1,
                  paddingTop: "0.5rem",
                  left: 0,
                }}
              >
                <button
                  style={{
                    background: "white",
                    border: "1px solid #00339b",
                    borderRadius: "6px",
                  }}
                  onClick={() => editContent(item, index)}
                >
                  <Icon name="edit" color="#00339b" />
                </button>
                <button
                  style={{
                    background: "white",
                    border: "1px solid #ba0b0be0",
                    borderRadius: "6px",
                  }}
                  onClick={() => removeContent(index)}
                >
                  <Icon name="trash" color="#ba0b0be0" />
                </button>
              </div>
              <>
                {item.image && (
                  <Col>
                    <img
                      data-dz-thumbnail=""
                      className="avatar-sm rounded bg-light"
                      alt=""
                      src={`${Constants.BASE_URL}${item.image}`}
                      style={{ width: "100%", height: "auto" }}
                    />
                  </Col>
                )}

                {item.description &&
                  stateToHTML(item.description.getCurrentContent()) !==
                    "<p><br></p>" && (
                    <Col className="h-blue">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: draftToHtml(
                            convertToRaw(item.description.getCurrentContent())
                          ),
                        }}
                      />
                    </Col>
                  )}
              </>
            </Row>
          ))}

          <FormGroup className="mt-2" style={{ marginBottom: "2rem" }}>
            <Label>Footer</Label>
            <Editor
              toolbarClassName="toolbarClassName"
              wrapperClassName="wrapperClassName"
              editorClassName="editorClassName"
              toolbar={{
                options: ["inline", "blockType", "link", "emoji", "image"],
                inline: { inDropdown: true },
                link: { inDropdown: true },
                image: { uploadCallback },
              }}
              editorState={footer}
              onEditorStateChange={(d: any) => setFooter(d)}
            />
          </FormGroup>

          <div className="row" style={{ marginTop: "1rem" }}>
            <div className="col-12 text-right">
              <ViewInWeb link={`https://mariomendez.uy/comercial`} />
              <button
                className="btn btn-primary waves-effect waves-light"
                onClick={() => save()}
              >
                Guardar
              </button>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Brokers;
